import { styled } from "@mui/material/styles";
import { Button, LinearProgress, SvgIcon } from "@mui/material";
import { SxProps, Theme } from "@mui/material";

export const AIIcon = styled(SvgIcon)({
    width: "16px",
    height: "16px",
    fill: "none",
    "& path": {
        fill: "#FFFFFF",
        stroke: "#ffff"
    }
});

export const AILinearProgress = styled(LinearProgress)({
    height: 3,
    backgroundColor: "rgba(121, 48, 217, 0.2)",
    "& .MuiLinearProgress-bar": {
        background: "linear-gradient(90deg, #F31779 0%, #7930D9 50%, #51247a 100%)"
    }
});

export const sidebarContent = (isMaximized: boolean): SxProps<Theme> => ({
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "greyscale.50",
    alignItems: "center",
    "& .copilotKitChat": {
        flex: 1,
        minHeight: 0,
        borderRadius: 0,
        boxShadow: "none",
        width: isMaximized ? "60vw" : "100%"
    },
    "& .copilotKitMessagesFooter .suggestions": {
        gap: 1
    },
    "& .copilotKitMessagesFooter .suggestion": ({ palette }: Theme) => ({
        backgroundColor: `${(palette as any).greyscale[100]} !important`,
        color: `${(palette as any).greyscale[700]} !important`,
        borderColor: `${(palette as any).greyscale[400]} !important`,
        borderRadius: "8px !important",
        fontFamily: "Inter",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "18px",
        letterSpacing: "0.24px",
        textTransform: "uppercase"
    })
});

const styles: Record<string, SxProps<Theme>> = {
    copilotHeader: {
        gap: "4px",
        padding: "12px 20px",
        borderBottom: "1px solid",
        borderColor: "greyscale.200",
        alignItems: "center",
        backgroundColor: "greyscale.50",
        justifyContent: "space-between"
    },
    copilotHeaderTypography: {
        color: "#48525C",
        flexGrow: "1",
        background: "linear-gradient(132deg, #F31779 0.9%, #994DBD 64.21%, #25C0E6 127.52%)",
        backgroundClip: "text",
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "600",
        lineHeight: "24px"
    },
    headerIconRow: {
        alignItems: "center",
        gap: "8px",
        width: "auto"
    },
    sidebarAIIcon: {
        width: 21,
        height: 21,
        "& path:first-of-type": { fill: "#6e7d8c", stroke: "transparent" }
    },
    headerActions: {
        display: "flex",
        alignItems: "center",
        gap: 1
    },
    toolbarAIIcon: {
        width: 21,
        height: 21
    },
    saasDisabledState: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: 2,
        px: 2,
        mt: -15,
        "& svg": {
            width: "240px",
            height: "240px"
        }
    },
    saasDisabledCenteredText: {
        textAlign: "center"
    }
};

export const settingsIconWrap = (isActive: boolean): SxProps<Theme> => ({
    "& svg": {
        color: isActive ? "primary.main" : "inherit",
        transition: "color 0.2s ease",
        fill: "none"
    }
});

// The single SidebarCollapse icon points one way; mirror it horizontally to read as "expand".
export const sidebarToggleIcon = (isMaximized: boolean): SxProps<Theme> => ({
    transform: isMaximized ? "scaleX(-1)" : "none",
    transition: "transform 0.2s ease",
    fill: "none"
});

export default styles;
